import { useEffect } from 'react';
import {
  getWhatsAppGroupUrl,
  initializeLandingTracking,
  trackWhatsAppGroupClick,
} from '../utils/landingTracking';
import './AutomotiveGroupLanding.css';

const META = {
  title: 'Grupo gratuito de oportunidades automotivas no WhatsApp',
  description:
    'Receba veículos abaixo do mercado, achados com baixa quilometragem e opções para diferentes faixas de preço.',
};

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M16.02 3a12.8 12.8 0 0 0-10.9 19.5L3.4 28.8l6.43-1.68A12.88 12.88 0 1 0 16.02 3Zm0 23.48c-1.96 0-3.88-.54-5.55-1.55l-.4-.24-3.81 1 1.02-3.72-.26-.41a10.58 10.58 0 1 1 9 4.92Zm5.8-7.92c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.72.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.34-.49-2.55-1.58a9.6 9.6 0 0 1-1.77-2.2c-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.18.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.36-.25-.61-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.08-1.11 2.64 0 1.56 1.14 3.06 1.3 3.27.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.15-1.51.26-.74.26-1.38.18-1.51-.08-.13-.29-.21-.61-.37Z"
      />
    </svg>
  );
}

export default function AutomotiveGroupLanding() {
  useEffect(() => {
    document.title = META.title;
    document.body.classList.add('automotive-landing-active');

    const metaDefinitions = [
      ['name', 'description', META.description],
      ['property', 'og:title', META.title],
      ['property', 'og:description', META.description],
      ['property', 'og:type', 'website'],
      ['property', 'og:locale', 'pt_BR'],
    ];

    metaDefinitions.forEach(([attribute, key, content]) => {
      let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attribute, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    });

    initializeLandingTracking();
    return () => document.body.classList.remove('automotive-landing-active');
  }, []);

  return (
    <main className="automotive-landing">
      <div className="automotive-landing__glow" aria-hidden="true" />
      <section className="automotive-landing__card" aria-labelledby="landing-title">
        <p className="automotive-landing__badge">
          <span aria-hidden="true" />
          GRUPO GRATUITO NO WHATSAPP
        </p>

        <h1 id="landing-title">
          Receba oportunidades automotivas direto no seu WhatsApp
        </h1>

        <p className="automotive-landing__support">
          Veículos abaixo do mercado, achados com baixa quilometragem e opções para
          diferentes faixas de preço.
        </p>

        <p className="automotive-landing__benefits" aria-label="Comprar, acompanhar e indicar">
          Comprar <span>•</span> Acompanhar <span>•</span> Indicar
        </p>

        <a
          className="automotive-landing__cta"
          href={getWhatsAppGroupUrl()}
          onClick={trackWhatsAppGroupClick}
          aria-label="Entrar gratuitamente no grupo de oportunidades automotivas no WhatsApp"
        >
          <WhatsAppIcon />
          <span>ENTRAR GRATUITAMENTE NO GRUPO</span>
        </a>

        <p className="automotive-landing__microcopy">
          Você será direcionado ao WhatsApp. Participação gratuita.
        </p>

        <p className="automotive-landing__legal">
          Ofertas sujeitas à disponibilidade. Confirme informações e condições antes de
          negociar.
        </p>
      </section>
    </main>
  );
}

